import { CALL_CONTROL_LABELS, CALL_END_REASON_LABELS, type AiAttentionState, type CallControlsSummary } from '@lia/contracts';
import { formatDuration, formatMoney } from '../../lib/format.js';
import { StatusBadge, type StatusTone } from '../primitives/badge.js';

// Setter §06.10 / §09.12: call controls (silence, duration, clarification) and the contact-level AI attention state
// after a possible-abuse flag (§06.10.3–4). Voice is pre-Phase 0: everything here is «sin verificar».

export const AI_ATTENTION_LABELS: Record<AiAttentionState, string> = {
  active: 'IA activa',
  paused: 'IA en pausa por posible abuso',
  blocked: 'Bloqueado para IA',
};
const AI_ATTENTION_TONE: Record<AiAttentionState, StatusTone> = { active: 'success', paused: 'warning', blocked: 'danger' };

export function AiAttentionBadge({ state, className }: { state: AiAttentionState; className?: string }) {
  return (
    <StatusBadge tone={AI_ATTENTION_TONE[state]} className={className}>
      {AI_ATTENTION_LABELS[state]}
    </StatusBadge>
  );
}

/** What the voice service did on a call: end reason, applied controls, duration and estimated cost. */
export function CallControlsPanel({ controls, className }: { controls: CallControlsSummary; className?: string }) {
  return (
    <div className={['grid gap-2', className].filter(Boolean).join(' ')}>
      <dl className="grid grid-cols-1 gap-2 text-body sm:grid-cols-3">
        <div>
          <dt className="text-meta text-text-secondary">Motivo de cierre</dt>
          <dd className="text-text-primary">{controls.endReason ? CALL_END_REASON_LABELS[controls.endReason] : 'Sin cierre automático'}</dd>
        </div>
        <div>
          <dt className="text-meta text-text-secondary">Duración</dt>
          <dd className="text-text-primary">{formatDuration(controls.durationSeconds)}</dd>
        </div>
        <div>
          <dt className="text-meta text-text-secondary">Costo estimado</dt>
          <dd className="text-text-primary">{controls.estimatedCost ? formatMoney(controls.estimatedCost) : <span className="italic text-text-secondary">Costo estimado desconocido</span>}</dd>
        </div>
      </dl>
      {controls.entries.length ? (
        <ol className="grid gap-1 text-body" aria-label="Controles aplicados">
          {controls.entries.map((e, i) => (
            <li key={`${e.at}-${i}`} className="flex flex-wrap gap-x-2 border-t border-border-subtle pt-1">
              <span className="text-text-primary">{CALL_CONTROL_LABELS[e.control]}</span>
              <span className="text-meta text-text-secondary">{formatDuration(e.elapsedSeconds)}</span>
              {e.detail ? <span className="text-meta text-text-secondary">— {e.detail}</span> : null}
            </li>
          ))}
        </ol>
      ) : null}
      <p className="text-meta text-text-secondary">Sin verificar: controles probados solo con dobles de prueba (Fase 0 de voz pendiente).</p>
    </div>
  );
}
